import BaseApp from 'js/app/base/BaseApp'
import ControllerManager from 'js/app/ControllerManager'

export default class App extends BaseApp {
  constructor(FxRouter, VcRouter, useAjax, options) {
    super(FxRouter, VcRouter, useAjax, options)

    this.controllerManager = new ControllerManager(VcRouter, FxRouter, useAjax)
  }
}
